import { Page, TagSpecDto } from '@ampsec/platform-client';
import { getApi } from 'Src/Api';

const PAGE_SIZE = 250;

export async function fetchAllTagSpecsCatalog(tid: string, includeGlobals: boolean): Promise<TagSpecDto[]> {
    const api = await getApi();
    if (!api?.tagSpecsService) {
        throw new Error('Platform API is not initialized');
    }

    if (typeof api.tagSpecsService.listAllForCatalog === 'function') {
        return api.tagSpecsService.listAllForCatalog({ tid, includeGlobals });
    }

    const all: TagSpecDto[] = [];
    let offset = 0;
    let hasMore = true;

    while (hasMore) {
        const response = await api.tagSpecsService.list({
            tid,
            limit: PAGE_SIZE,
            offset,
            ...(offset === 0 && includeGlobals ? { includeGlobals: true } : {}),
        });

        if (response?.error) {
            throw response.error;
        }

        const page = response.data as Page<TagSpecDto>;
        all.push(...(page.data ?? []));

        offset += PAGE_SIZE;
        hasMore = page.hints?.hasMore ?? false;
    }

    return all;
}
